const getAbi = async function () {
  const abi = await $.get('../../app/assets/abis/abi.json');
  return abi.abi;
};
const connectMetamask = async function () {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send('eth_requestAccounts', []);
    const signer = provider.getSigner();
    const walletAddress = await signer.getAddress();
    return { signer, walletAddress };
  } catch (err) {
    if (err.code === 4001) {
      $('#reject_metamask').modal('show');
      return;
    }
    if (err.code === 'INVALID_ARGUMENT') {
      $('#metamask_not_found').modal('show');
    }
    console.error(err);
  }
};
const allNftsCount = $('.count>span').text().trim();
const allNfts = $('.catalog__list').html();
$('.show-nfts').on('click', async function () {
  try {
    const { signer, walletAddress } = await connectMetamask();
    const abi = await getAbi();
    const address = '0x8ef5Bb4be4Bf31ecAFb92eAE6cA7bFcA05CBE59F';
    const contract = new ethers.Contract(address, abi, signer);
    const nftListForUserHex = await contract.showListNFTForOwner(walletAddress);
    const nftListForUser = nftListForUserHex.map((id) => id.toString());
    const nfts = await jQuery.ajax({
      url: '/nftGallery/myNFT',
      method: 'get',
      data: { nftListForUser }
    });
    let yourNftsCount;
    let yourNfts;
    const lang = nfts.lang;
    switch (lang) {
      case 'pl': {
        yourNftsCount = 'Twoich NFT: ' + nfts.count;
        showYourNfts = 'Zobacz swoje NFT';
        showAllNfts = 'Zobacz wszystkie NFT';
        nftBanner = '<h2>Nie posiadasz jeszcze żadnych NFT</h2>';
        break;
      }
      case 'en': {
        yourNftsCount = 'Your NFTs: ' + nfts.count;
        showYourNfts = 'Show your NFTs';
        showAllNfts = 'Show all NFTs';
        nftBanner = "<h2>You don't have any NFTs yet</h2>";
        break;
      }
      case 'de': {
        yourNftsCount = 'Deine NFTs: ' + nfts.count;
        showYourNfts = 'Zeige deine NFTs';
        showAllNfts = 'Zeige alle NFTs';
        nftBanner = '<h2>Du hast noch keine NFTs</h2>';
        break;
      }
      case 'fr': {
        yourNftsCount = 'Vos NFTs: ' + nfts.count;
        showYourNfts = 'Voir vos NFTs';
        showAllNfts = 'Voir toutes les NFTs';
        nftBanner = "<h2>Vous n'avez pas encore de NFTs</h2>";
        break;
      }
    }

    $('.catalog__list').html(nfts.html);
    $('.pagination').toggle();
    $(this).text($(this).text() == showYourNfts ? showAllNfts : showYourNfts);
    if ($(this).text() == showAllNfts) {
      $('.count>span').text(allNftsCount);
      $('.catalog__list').html(allNfts);
    } else {
      $('.count>span').text(yourNftsCount);
      if (nfts.html === null) {
        $('.catalog__list').append(nftBanner).css('text-align', 'center');
      }
    }
  } catch (err) {
    console.error(err);
    $('.modal.short').popup();
  }
});
